module.exports = __webpack_public_path__ + "img/resultados.c8f90691.jpg";